import React, { useContext } from 'react';
import { Button, chakra } from '@chakra-ui/react';
import LocalisedLink from './LocalisedLink';
import { LocaleContext } from './Layout';

type Props = {
  cta?: string;
  link: {
    __typename?: string;
    slug: string;
  };
  arialabel: string;

  variant?: string;

  mt?: string;
  size?: string;
};

const ButtonStyle = chakra(Button, {
  baseStyle: {
    a: {
      ':hover': {
        textDecoration: 'none',
      },
    },
  },
});

/** A styled link used in components */
const CtaLink = ({ cta, link, variant, arialabel, mt, size }: Props) => {
  const { product, location } = useContext(LocaleContext);

  const defaultCta = !cta && product === 'safety' ? 'Get Started' : 'Book Demo';

  // if we made it this far this link is internal. Now we are going to test if the type of page we are linking to has any translations
  const noLang =
    link?.__typename === 'DatoCmsArticle' ||
    link?.__typename === 'DatoCmsLandingPage' ||
    link?.__typename === 'DatoCmsPositionsAvailable' ||
    link?.__typename === 'manual';
  return (
    <LocalisedLink noLang={noLang} to={datoSlug(link)}>
      <ButtonStyle
        px="6"
        py="2"
        mt={mt}
        size={size}
        aria-label={arialabel}
        variant={variant}
      >
        {cta || defaultCta}
      </ButtonStyle>
    </LocalisedLink>
  );
};

export default CtaLink;

/** This function will make sure it ads in gatsby generated url paths to a link which has been generated by datoCMS  */
export const datoSlug = (link) => {
  if (link === null) {
    return null;
  }

  if (link.__typename === 'DatoCmsArticle') {
    return `/blog/${link.slug}`;
  }
  if (link.__typename === 'DatoCmsPositionsAvailable') {
    return `/about-us/careers/${link.slug}`;
  }

  if (link.__typename === 'DatoCmsFeaturePage') {
    let path = '/';

    if (link.treeParent) {
      if (link.treeParent.treeParent) {
        path = `/${link.treeParent.treeParent.slug}/${link.treeParent.slug}/${link.slug}`;
      } else {
        path = `/${link.treeParent.slug}/${link.slug}`;
      }
    } else {
      path = `/${link.slug}/`;
    }

    return path;
  }
  if (link.__typename === 'DatoCmsLandingPage') {
    return `/info/${link.slug}`;
  }
  if (link.__typename === 'external') {
    return link.slug;
  }
};
